import adminWithdrawApplications from '@/router/modules/admin_withdraw_applications'
import admins from '@/router/modules/admins'
import advertisementClickRecordsRouter from '@/router/modules/advertisement_click_records_router'
import advertisementsRouter from '@/router/modules/advertisements_router'
import advertisingSpaces from '@/router/modules/advertising_spaces'
import alarmNotificationRulesRouter from '@/router/modules/alarm_notification_rules_router'
import alarmWhitelists from '@/router/modules/alarm_whitelists'
import alarmsRouter from '@/router/modules/alarms_router'
import appConfigure from '@/router/modules/app_configure'
import appPages from '@/router/modules/app_pages'
import bankAccountsRouter from '@/router/modules/bank_accounts_router'
import billingRuleTemperatureTimersRouter from '@/router/modules/billing_rule_temperature_timers_router'
import billingRuleTimersRouter from '@/router/modules/billing_rule_timers_router'
import billingRulesRouter from '@/router/modules/billing_rules_router'
import carsRouter from '@/router/modules/cars_router'
import chargeChannelsRouter from '@/router/modules/charge_channels_router'
import chargeStations from '@/router/modules/charge_stations'
import chargers from '@/router/modules/chargers'
import chargingCardConsumptionRecordsRouter from '@/router/modules/charging_card_consumption_records_router'
import chargingCardDefinitionsRouter from '@/router/modules/charging_card_definitions_router'
import chargingCardsRouter from '@/router/modules/charging_cards_router'
import chargingPackageDefinitions from '@/router/modules/charging_package_definitions'
import chargingPackageSettlementRulesRouter from '@/router/modules/charging_package_settlement_rules_router'
import chargingPackageSettlementsRouter from '@/router/modules/charging_package_settlements_router'
import couponDefinitionsRouter from '@/router/modules/coupon_definitions_router'
import coupons from '@/router/modules/coupons'
import deviceOrdersRouter from '@/router/modules/device_orders_router'
import deviceTestReportsRouter from '@/router/modules/device_test_reports_router'
import discountSettlementRulesRouter from '@/router/modules/discount_settlement_rules_router'
import discountSettlementsRouter from '@/router/modules/discount_settlements_router'
import ecaRuleOutcomes from '@/router/modules/eca_rule_outcomes'
import enumerationsRouter from '@/router/modules/enumerations_router'
import equipmentDispatchesRouter from '@/router/modules/equipment_dispatches_router'
import equipmentProductionsRouter from '@/router/modules/equipment_productions_router'
import evChargingStationDailySettlementsRouter from '@/router/modules/ev_charging_station_daily_settlements_router'
import evChargingStationSettlementsRouter from '@/router/modules/ev_charging_station_settlements_router'
import evChargingStations from '@/router/modules/ev_charging_stations'
import evcsChargeRecords from '@/router/modules/evcs_charge_records'
import evcsConnectors from '@/router/modules/evcs_connectors'
import evcsEcmpOrders from '@/router/modules/evcs_ecmp_orders'
import evcsNotificationOrders from '@/router/modules/evcs_notification_orders'
import evcsOperators from '@/router/modules/evcs_operators'
import evcsOrders from '@/router/modules/evcs_orders'
import evcsStations from '@/router/modules/evcs_stations'
import evcsTraces from '@/router/modules/evcs_traces'
import feedbacks from '@/router/modules/feedbacks'
import giftCardDefinitionsRouter from '@/router/modules/gift_card_definitions_router'
import giftCardRedemptionRecordsRouter from '@/router/modules/gift_card_redemption_records_router'
import groupApplications from '@/router/modules/group_applications'
import groupTransactionRecords from '@/router/modules/group_transaction_records'
import groupsRouter from '@/router/modules/groups_router'
import idleFeeBillSettlementsRouter from '@/router/modules/idle_fee_bill_settlements_router'
import idleFeeBillsRouter from '@/router/modules/idle_fee_bills_router'
import idleFeeSettlementRulesRouter from '@/router/modules/idle_fee_settlement_rules_router'
import idleFeesRouter from '@/router/modules/idle_fees_router'
import insertingGunStartRecordsRouter from '@/router/modules/inserting_gun_start_records_router'
import invoicesRouter from '@/router/modules/invoices_router'
import magcardSwipeRecordsRouter from '@/router/modules/magcard_swipe_records_router'
import magcardsRouter from '@/router/modules/magcards_router'
import materialTemplatesRouter from '@/router/modules/material_templates_router'
import materialsRouter from '@/router/modules/materials_router'
import membershipRouter from '@/router/modules/membership_router'
import modelVersionLogAudits from '@/router/modules/model_version_log_audits'
import notificationRecordsRouter from '@/router/modules/notification_records_router'
import notificationSubscriptionsRouter from '@/router/modules/notification_subscriptions_router'
import notifications from '@/router/modules/notifications'
import nvrChannelsRouter from '@/router/modules/nvr_channels_router'
import operationActivities from '@/router/modules/operation_activities'
import orderRefundsRouter from '@/router/modules/order_refunds_router'
import orderSettlements from '@/router/modules/order_settlements'
import orderStatisticsRouter from '@/router/modules/order_statistics_router'
import ordersRouter from '@/router/modules/orders_router'
import parkingLocks from '@/router/modules/parking_locks'
import parkingReliefCodes from '@/router/modules/parking_relief_codes'
import parkingReliefRecordsRouter from '@/router/modules/parking_relief_records_router'
import parkingReliefsRouter from '@/router/modules/parking_reliefs_router'
import pickupLocations from '@/router/modules/pickup_locations'
import pointRecords from '@/router/modules/point_records'
import postsRouter from '@/router/modules/posts_router'
import productOrdersRouter from '@/router/modules/product_orders_router'
import productReturnApplicationsRouter from '@/router/modules/product_return_applications_router'
import products from '@/router/modules/products'
import reports from '@/router/modules/reports'
import roles from '@/router/modules/roles'
import serviceProviderTransactionRecords from '@/router/modules/service_provider_transaction_records'
import serviceProviderWithdrawApplicationStatistics from '@/router/modules/service_provider_withdraw_application_statictics'
import serviceProviderWithdrawApplications from '@/router/modules/service_provider_withdraw_applications'
import serviceProviders from '@/router/modules/service_providers'
import settlementDiscountsRouter from '@/router/modules/settlement_discounts_router'
import settlementRules from '@/router/modules/settlement_rules'
import startAppointmentsRouter from '@/router/modules/start_appointments_router'
import stationActivities from '@/router/modules/station_activities'
import stationCommentRepliesRouter from '@/router/modules/station_comment_replies_router'
import stationComments from '@/router/modules/station_comments'
import subscriptionTriggerRecordsRouter from '@/router/modules/subscription_trigger_records_router'
import systemSettings from '@/router/modules/system_settings'
import tagsRouter from '@/router/modules/tags_router'
import taskDefinitionsRouter from '@/router/modules/task_definitions_router'
import tasksRouter from '@/router/modules/tasks_router'
import themes from '@/router/modules/themes'
import thirdPartyServiceTracesRouter from '@/router/modules/third_party_service_traces_router'
import topUpStatistics from '@/router/modules/top_up_statistics'
import topUps from '@/router/modules/top_ups'
import triggersRouter from '@/router/modules/triggers_router'
import userStatistics from '@/router/modules/user_statistics'
import usersRouter from '@/router/modules/users_router'
import vinBlacklistsRouter from '@/router/modules/vin_blacklists_router'
import vinRecordsRouter from '@/router/modules/vin_records_router'
import vipChargeStationsRouter from '@/router/modules/vip_charge_stations_router'
import vipMembersRouter from '@/router/modules/vip_members_router'
import virtualUsersRouter from '@/router/modules/virtual_users_router'
import withdrawApplications from '@/router/modules/withdraw_applications'
import workOrdersRouter from '@/router/modules/work_orders_router'
import chargePointsRouter from '@/router/modules/charge_points_router'

export default [
  adminWithdrawApplications,
  admins,
  advertisementClickRecordsRouter,
  advertisementsRouter,
  advertisingSpaces,
  alarmNotificationRulesRouter,
  alarmWhitelists,
  alarmsRouter,
  appConfigure,
  appPages,
  bankAccountsRouter,
  billingRuleTemperatureTimersRouter,
  billingRuleTimersRouter,
  billingRulesRouter,
  carsRouter,
  chargeChannelsRouter,
  chargeStations,
  chargers,
  chargingCardConsumptionRecordsRouter,
  chargingCardDefinitionsRouter,
  chargingCardsRouter,
  chargingPackageDefinitions,
  chargingPackageSettlementRulesRouter,
  chargingPackageSettlementsRouter,
  couponDefinitionsRouter,
  coupons,
  deviceOrdersRouter,
  deviceTestReportsRouter,
  discountSettlementRulesRouter,
  discountSettlementsRouter,
  ecaRuleOutcomes,
  enumerationsRouter,
  equipmentDispatchesRouter,
  equipmentProductionsRouter,
  evChargingStationDailySettlementsRouter,
  evChargingStationSettlementsRouter,
  evChargingStations,
  evcsChargeRecords,
  evcsConnectors,
  evcsEcmpOrders,
  evcsNotificationOrders,
  evcsOperators,
  evcsOrders,
  evcsStations,
  evcsTraces,
  feedbacks,
  giftCardDefinitionsRouter,
  giftCardRedemptionRecordsRouter,
  groupApplications,
  groupTransactionRecords,
  groupsRouter,
  idleFeeBillSettlementsRouter,
  idleFeeBillsRouter,
  idleFeeSettlementRulesRouter,
  idleFeesRouter,
  insertingGunStartRecordsRouter,
  invoicesRouter,
  magcardSwipeRecordsRouter,
  magcardsRouter,
  materialTemplatesRouter,
  materialsRouter,
  membershipRouter,
  modelVersionLogAudits,
  notificationRecordsRouter,
  notificationSubscriptionsRouter,
  notifications,
  nvrChannelsRouter,
  operationActivities,
  orderRefundsRouter,
  orderSettlements,
  orderStatisticsRouter,
  ordersRouter,
  parkingLocks,
  parkingReliefCodes,
  parkingReliefRecordsRouter,
  parkingReliefsRouter,
  pickupLocations,
  pointRecords,
  postsRouter,
  productOrdersRouter,
  productReturnApplicationsRouter,
  products,
  reports,
  roles,
  serviceProviderTransactionRecords,
  serviceProviderWithdrawApplicationStatistics,
  serviceProviderWithdrawApplications,
  serviceProviders,
  settlementDiscountsRouter,
  settlementRules,
  startAppointmentsRouter,
  stationActivities,
  stationCommentRepliesRouter,
  stationComments,
  subscriptionTriggerRecordsRouter,
  systemSettings,
  tagsRouter,
  taskDefinitionsRouter,
  tasksRouter,
  themes,
  thirdPartyServiceTracesRouter,
  topUpStatistics,
  topUps,
  triggersRouter,
  userStatistics,
  usersRouter,
  vinBlacklistsRouter,
  vinRecordsRouter,
  vipChargeStationsRouter,
  vipMembersRouter,
  virtualUsersRouter,
  withdrawApplications,
  workOrdersRouter,
  chargePointsRouter
]
